export default __webpack_public_path__ + "static/media/agent.1285d522.jpg";